// extracted by mini-css-extract-plugin
export default {"group":"ConnectedGroup_group__bEkTK","initialized":"ConnectedGroup_initialized__RUgak","wrap":"ConnectedGroup_wrap__SragR","asColumn":"ConnectedGroup_asColumn__iWnvt"};